import { IconCalendarMonth, IconChartBar, IconClockHour10, IconCopy, IconHandClick, IconTrash } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import TableComponent from '../../components/DataTable/TableComponent';
import DateRange from '../../components/DateRange/DateRange';
import DropDown from '../../components/DropDown/DropDown';
import Pagination from '../../components/Pagination/Pagination';
import DateFilterInfoPopup from '../../components/Popover/DateFilterInfoPopup';
import SearchComponent from '../../components/Search/SearchComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { dateIntoYYYY_MM_DD, formatDateToShortMonthDayYear, matchDateTimeConvert } from '../../utils/dateTimeConverter';
import EditQrModal from '../QRCode/Components/EditQrModal';
import CreateLinkModal from './Components/CreateLinkModal';
import LinkShareModal from './Components/LinkShareModal';
import ScheduleExpireLinkModal from './Components/ScheduleExpireLinkModal';
import { accessCheck } from '../../utils/accessCheck';
import { accessKeys } from '../../statics/accessKeys';

const Links = () => {
    const sortingFilterList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Clicks H-L",
            value: 'linkClicks,DESC'
        }, {
            id: 2,
            name: "Clicks L-H",
            value: 'linkClicks,ASC'
        }
    ]
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchData, setSearchData] = useState('');
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [sortFilter, setSortFilter] = useState(null);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getList() {
        loadingShow();
        let sortingFilterLocal = sortingFilterList?.find(item => item?.name == sortFilter)
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let url = `${urlApi.getLinkList}?page=${activePage}&limit=${perPage}&`;
        if (searchData) {
            url += "search=" + searchData + "&"
        }
        if (sortingFilterLocal?.id) {
            url += `sort=${sortingFilterLocal ? sortingFilterLocal?.value : null}&`
        }
        let resp = await postApi((date?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    function onSortingFilterChange(sort) {
        setActivePage(1)
        setSortFilter(sort)
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewLinkList)) {
            getList();
        }
        return () => {
        };
    }, [activePage, searchData, date, sortFilter]);

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("Link copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    function reset() {
        setActivePage(1);
        setSearchData('');
        setDate({ startDate: '', endDate: '' });
        setSortFilter(null);
    }

    async function deleteLink(linkId) {
        loadingShow();
        let resp = await getApi(urlApi.deleteLink + linkId);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            reset();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        {
            name: "", selector: (row) => row?.channel_name, grow: 3.2, cell: (row) => (
                <div className='flex items-start py-2 gap-2 !px-2.5'>
                    <div className="bg-[var(--primary-30)] p-1.5 h-8 w-8 aspect-square rounded-full">
                        <img src={row?.favicon} alt="" className='h-full w-full aspect-square object-cover' />
                    </div>
                    <div className="text-left">
                        <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.linkName}</p>
                        <Link to={row?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{row?.shortLink}</p></Link>
                        <Link to={row?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)] break-all">{row?.mainLink}</p></Link>
                        {row?.expiryLinkFallback && <div className='mb-0.5 flex items-center !gap-1'><IconClockHour10 size={16} /> <Link to={row?.expiryLinkFallback} target='_blank'><p className="text-xs italic text-[var(--black)]">{row?.expiryLinkFallback}</p></Link></div>}
                        <div className="flex gap-2 flex-wrap">
                            <p className={`font-semibold text-[10px] ${row?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {row?.linkClicks ?? "0"} engagements</p>
                            <p className={`font-semibold text-[10px] ${row?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {row?.uniqueLinkClicks ?? "0"} unique clicks</p>
                            <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(row?.createdAt)}</p>
                            {row?.expiryTime && <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconClockHour10 size={16} /> </span> {matchDateTimeConvert(row?.expiryTime)}</p>}
                        </div>
                    </div>
                </div>
            )
        }, {
            name: "", center: "true", grow: 1.5, selector: (row) => row?.category, cell: (row) => (
                <div className="flex gap-2 items-center flex-wrap justify-center !px-3">
                    <IconButton icon={< IconCopy size={16} />} text={"Copy"} onClickFunction={() => onCopy(row?.shortLink)} />
                    <LinkShareModal shareUrl={row?.shortLink} type={'short link'} />
                    {accessCheck(accessKeys?.viewLinkDetails) && <Link to={"/link-details"} state={row} className='no-underline'>  <IconButton icon={< IconChartBar size={16} />} text={"Details"} /></Link>}
                    {accessCheck(accessKeys?.updateDestinationLink) && <EditQrModal baseData={row} callback={() => reset()} />}
                    {accessCheck(accessKeys?.setLinkExpiry) && <ScheduleExpireLinkModal baseData={row} callback={() => getList()} />}
                    {accessCheck(accessKeys?.deleteLink) && <ConfirmationModal buttonComponent={<IconButton icon={<IconTrash size={16} />} />} confirmationText={"Are You Sure Want To Delete This Link?"} onConfirm={() => deleteLink(row?._id)} />}
                </div>
            )
        }
    ];

    return (
        <Layout>
            <div className="flex mb-3 items-center gap-3 flex-wrap">
                <SearchComponent onClear={() => { document.getElementById("link-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("link-table-search")?.value); setActivePage(1) }} inputId='link-table-search' placeholder={"Search Links..."} />
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />
                {date?.startDate && <DateFilterInfoPopup />}
                <DropDown title={"Sort By"} list={sortingFilterList?.map(item => item?.name)} defaultValue={sortFilter} onSelect={(name) => onSortingFilterChange(name)} />
                {accessCheck(accessKeys?.generateShortLink) && <CreateLinkModal callback={() => reset()} />}
            </div>
            <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Links</p>
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </Layout>
    )
}

export default Links